import { getLocale } from "@/data/regionInfo";
import model3D from '@/mixins/Customizer/Model3D';
import { external3DScene } from '@/mixins/external3DScene';
import Vue from "vue";

export default {
  mixins: [model3D, external3DScene],
  data() {
    return {
      iconCheckColor: 'white',
      images: [{}],
      imagesLoaded: 0
    };
  },
  computed: {
    colors() {
      return this.$store.getters['personalization/getItemsData'][0].font_colors;
    },
    getCurrentStep() {
      return this.$store.state.personalization.currentStep;
    },
    isSideModel() {
      return [
        'authentic-classic',
        'authentic-classic-kids',
        'authentic-classic-toddler',
        'comfycush-authentic',
        'skate-authentic',
        'mte-old-skool',
        'authentic-classic-wide',
      ].includes(this.$store.state.utils.pdm.sku);
    },
    isTallModel() {
      return ['mte-sk8-hi-2-dx', 'mte-sk8-hi'].includes(this.$store.state.utils.pdm.sku);
    },
    isUGCApplied() {
      const ugcSize = this.$recipe.getUGCSizeFromRecipe();

      return this.$recipe.checkUGCByType({ includeUGCAsSwatch: true, customUGC: true })
        && ugcSize && this.$store.state.utils.bucketSizes[ugcSize] > 9 ;
    },
    itemsToPersonalize() {
      return this.$store.getters['personalization/getItemsData'].length;
    },
  },
  methods: {
    /**
     * @function setImages
     * This method add response images to images array.
     */
    setImages(featuredView, data) {
      this.images = featuredView.map(element => {
        const key = element.view + '_view';

        return { caption: key, imgSrc: data[key][element.size] };
      });
		},
    /**
     * @function setImages
     * This method add snapshot service response images to images array.
     */
    setSnapShotImages(data) {
      const recipe = this.$store.getters['ugc/tempData/getRecipe'];
      const {components} = recipe;
      const check = components && Object.keys(components).find( item => components[item].hasOwnProperty("personalization"));

      const { pdm } = this.$store.state.utils;
      const featured_views = pdm.product_images.featured_views.embroidery;
      this.disposeScene();
      let generateRightShoe = false;
      featured_views.forEach(async (v,index) => {
        if(data.fileUrl.includes(v.view) && data.fileUrl.includes(v.size)) {
          const item = ({
            caption : v.view + '_view',
            imgSrc: data.fileUrl
          })
          Vue.set(this.images,index,item);
          if(index===0) generateRightShoe = true;
        };
        if(generateRightShoe && index == 1) {
          await this.initExternal3Dscene({domEl: `snapshot-image-scene`, snapshotSize: v.size, snapshotView: v.view, showSnapShot: true, embroidery: !!check, embroideryIndex: 1});
        }
      });
    },

    /**
     * @function callImageService
     * This method calls product images service.
     */
    async callImageService() {
      this.$eventBus.$emit('hide-customs-spinner', false);
      this.imagesLoaded = 0;

      const { pdm, configuration } = this.$store.state.utils;
      let featuredView = typeof pdm.product_images.featured_views.embroidery !== 'undefined' ?
        pdm.product_images.featured_views.embroidery : [
          { size: 'square', view: 'back_left' },
          { size: 'square', view: 'back' },
        ];
      await this.$nextTick();
      if(configuration.enableSnapshotService) {
          const recipe = this.$store.getters['ugc/tempData/getRecipe'];
          const {components} = recipe;
          const check = components && Object.keys(components).find( item => components[item].hasOwnProperty("personalization"));
          await this.$store.dispatch("recipe/SAVE_RECIPE", {recipe});
          const v = featuredView[0];
          this.initExternal3Dscene({domEl: 'snapshot-image-scene', snapshotSize: v.size, snapshotView: v.view, showSnapShot: true, embroidery: !!check, embroideryIndex: 0});
      } else  {
        let recipe = this.$store.getters['ugc/tempData/getRecipe'];
        this.$store.dispatch('ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE', {
            recipe_id: recipe.recipe_id,
            locale: getLocale(),
            recipe: recipe,
            images: featuredView
          })
          .then(data => {
            this.setImages(featuredView, data);
          })
          .catch(console.error);
      }
    },

    imageIsLoaded() {
      this.imagesLoaded++;
      if (this.itemsToPersonalize === this.imagesLoaded) {
        this.$emit('images-loaded');
        this.$eventBus.$emit("hide-customs-spinner", true);
      }
    },
  },
  created() {
    this.callImageService();
    this.$eventBus.$on("snapshot-complete", this.setSnapShotImages);
  },
  mounted() {
    if (this.$store.getters['personalization/isPersonalizationInComponentRecipe']() &&
      this.$store.state.personalization.recipeData.length === 0) {
      this.showApplyButton = false;
      const colorName = this.$store.state.recipe.recipe_v2
        .components[this.$store.getters['personalization/getPersonalizationComponentName']]
        .personalization[0].color;

      if (colorName === 'white') {
        this.iconCheckColor = 'black';
      } else {
        this.iconCheckColor = 'white';
      }
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("snapshot-complete",this.setSnapShotImages);
    this.disposeScene();
  },
};
